import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OnlineServiceInterface } from '@nts/std/interfaces';

@Injectable({
  providedIn: 'root'
})
export class OnlineService implements OnlineServiceInterface {
  isOnline$ = new BehaviorSubject<boolean>(window.navigator.onLine);

  constructor() {
    this.listenToOnlineStatus();
  }

  listenToOnlineStatus(): void {
    window.addEventListener('online', () => this.isOnline$.next(true));
    window.addEventListener('offline', () => this.isOnline$.next(false));
  }

  get isOnline(): boolean {
    return window.navigator.onLine;
  }
}